/**
 * Dashboard Comments Chips - Duplicated from My Candidates CandidatesChips
 * Same structure: ChipsContainer, watch form values, "FilterName : Value" format
 */
import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ChipsContainer } from 'app/ComponentLibrary/Filter';
import { DashboardCommentsFilterName } from './DashboardFilterUtils';

export interface DashboardCommentsChipsProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
}

export const DashboardCommentsChips: React.FC<DashboardCommentsChipsProps> = ({ onApplyFilter }) => {
  const { getValues, setValue, watch } = useFormContext();

  const search = watch(DashboardCommentsFilterName.search);
  const placementId = watch(DashboardCommentsFilterName.placementId);
  const taskId = watch(DashboardCommentsFilterName.taskId);
  const rootTaskId = watch(DashboardCommentsFilterName.rootTaskId);
  const entityType = watch(DashboardCommentsFilterName.entityType);
  const dateRange = watch(DashboardCommentsFilterName.dateRange);

  const chips = React.useMemo(() => {
    const result: Record<string, { label: string; enableDelete: boolean; value: unknown }[]> = {};
    if (search && String(search).trim()) {
      result.search = [
        { label: `Search : ${search}`, enableDelete: true, value: search },
      ];
    }
    if (placementId && String(placementId).trim()) {
      result.placementId = [
        { label: `Placement ID : ${placementId}`, enableDelete: true, value: placementId },
      ];
    }
    if (taskId && String(taskId).trim()) {
      result.taskId = [
        { label: `Task ID : ${taskId}`, enableDelete: true, value: taskId },
      ];
    }
    if (rootTaskId && String(rootTaskId).trim()) {
      result.rootTaskId = [
        { label: `Root Task ID : ${rootTaskId}`, enableDelete: true, value: rootTaskId },
      ];
    }
    const entityVal = entityType && typeof entityType === 'object' && 'value' in entityType ? (entityType as { value: string }).value : null;
    if (entityVal && String(entityVal).trim()) {
      const label = entityVal === 'external_task' ? 'External Task' : entityVal === 'cue_note' ? 'Cue Note' : entityVal;
      result.entityType = [
        { label: `Entity : ${label}`, enableDelete: true, value: entityType },
      ];
    }
    if (dateRange && (dateRange.startDate || dateRange.endDate)) {
      const start = dateRange.startDate ? new Date(dateRange.startDate).toLocaleDateString() : '…';
      const end = dateRange.endDate ? new Date(dateRange.endDate).toLocaleDateString() : '…';
      result.dateRange = [
        { label: `Date Range : ${start} – ${end}`, enableDelete: true, value: dateRange },
      ];
    }
    return result;
  }, [search, placementId, taskId, rootTaskId, entityType, dateRange]);

  const handleChipDelete = (field: string) => {
    const values = getValues();
    if (field === DashboardCommentsFilterName.search) {
      setValue(DashboardCommentsFilterName.search, '');
      onApplyFilter({ ...values, search: '' });
    } else if (field === DashboardCommentsFilterName.placementId) {
      setValue(DashboardCommentsFilterName.placementId, '');
      onApplyFilter({ ...values, placementId: '' });
    } else if (field === DashboardCommentsFilterName.taskId) {
      setValue(DashboardCommentsFilterName.taskId, '');
      onApplyFilter({ ...values, taskId: '' });
    } else if (field === DashboardCommentsFilterName.rootTaskId) {
      setValue(DashboardCommentsFilterName.rootTaskId, '');
      onApplyFilter({ ...values, rootTaskId: '' });
    } else if (field === DashboardCommentsFilterName.entityType) {
      setValue(DashboardCommentsFilterName.entityType, null);
      onApplyFilter({ ...values, entityType: null });
    } else if (field === DashboardCommentsFilterName.dateRange) {
      setValue(DashboardCommentsFilterName.dateRange, null);
      onApplyFilter({ ...values, dateRange: null });
    }
  };

  if (Object.keys(chips).length === 0) return null;

  return (
    <Box sx={{ px: 1.5, pb: 1, pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
      <ChipsContainer chips={chips} onClick={() => {}} onDelete={handleChipDelete} />
    </Box>
  );
};
